module.exports = __webpack_public_path__ + "media/components/footer/static/logo-x-b3e42fb6f667f0f9e135efa8fcfac4b0.svg";